import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kanji-cdeck',
  templateUrl: './card-deck.component.html',
  styleUrls: ['./card-deck.component.css']
})
export class CardDeckComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
